import {
  BannerModule as EdsBannerModule,
  ButtonModule,
  PaddingModule,
  SpacingModule,
  GridModule,
  FlexboxModule,
  LinkItemModule,
  IconModule,
  TooltipModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { BannerComponent } from './banner.component';
import { TranslateModule } from '@shared/translate/translate.module';
import { PipesModule } from '@shared/pipes/pipes.module';

@NgModule({
  declarations: [BannerComponent],
  imports: [
    BrSdkModule,
    ButtonModule,
    CommonModule,
    EdsBannerModule,
    PaddingModule,
    SpacingModule,
    GridModule,
    TranslateModule,
    FlexboxModule,
    LinkItemModule,
    IconModule,
    PipesModule,
    TooltipModule,
  ],
  exports: [BannerComponent],
  entryComponents: [BannerComponent],
})

/**
 * Article Module
 */
export class BannerModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      Banner: BannerComponent,
      'Banner (with nav)': BannerComponent,
      'Banner Impact': BannerComponent,
      'Banner Impact VI': BannerComponent,
      'Banner Video': BannerComponent,
      'Standard Banner Image/Gradient': BannerComponent,
      'Banner 50/50': BannerComponent,
    };
  }
}
